import React from 'react'
import CopyButton from 'ui/atoms/CopyButton'
import buildResourceIframe from 'utils/FormBuilder/iframeBuilder'

import Ui from '../../ui'

function PublicUrlModal({ isVisible, formName, onClose, publicUrl, onCopy }) {
  const [hasUrlCopy, setHasUrlCopy] = React.useState(false)
  const [embedCopied, setEmbedCopied] = React.useState(false)

  const LinkComponent = React.useCallback(
    (link: string, isIframe: boolean = false) => {
      return (
        <div className="flex items-center rounded bg-gray-200 py-2 pl-3 pr-2">
          {!isIframe ? (
            <a
              className="flex-1 text-xs text-gray-700"
              href={link}
              rel="noopener noreferrer"
              target="_blank"
            >
              {link}
            </a>
          ) : (
            <span className="flex-1 text-xs text-gray-700">{link}</span>
          )}
          <CopyButton
            onCopy={() => {
              if (isIframe) {
                setHasUrlCopy(false)
                setEmbedCopied(true)
              } else {
                setHasUrlCopy(true)
                setEmbedCopied(false)
              }
              if (onCopy) {
                onCopy()
              }
            }}
            showCopied={(embedCopied && isIframe) || (hasUrlCopy && !isIframe)}
            text={link}
          />
        </div>
      )
    },
    [embedCopied, hasUrlCopy, onCopy]
  )

  return (
    <Ui.ModalDialog
      onClose={() => {
        setEmbedCopied(false)
        setHasUrlCopy(false)
        if (onClose) {
          onClose()
        }
      }}
      opened={isVisible}
      title={`${formName || ''} ${formName ? 'p' : 'P'}ublic URL`}
    >
      <div className="mt-4">
        <h2 className="pb-1 text-sm">Share a link</h2>
        {LinkComponent(publicUrl)}
      </div>

      <div className="mt-4">
        <h2 className="pb-1 text-sm">Embed on your site</h2>
        {LinkComponent(buildResourceIframe(publicUrl), true)}
      </div>
    </Ui.ModalDialog>
  )
}

export default PublicUrlModal
